import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  id: "addManualComp",
  class: "needs-validation",
  novalidate: "",
  style: {"max-height":"500px","overflow-y":"auto","overflow-x":"hidden"}
}
const _hoisted_2 = { class: "col-md-1 pt-2 me-1" }
const _hoisted_3 = { class: "fw-bold text-nowrap noselect" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = ["value", "onKeyup"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Street address is required.", -1)
const _hoisted_7 = { class: "col-md-2" }
const _hoisted_8 = ["value", "onKeyup"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "invalid-feedback" }, "Zip is required.", -1)
const _hoisted_10 = { class: "col-md-1 pt-2" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt p-color-1" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { class: "row mt-2" }
const _hoisted_15 = { class: "col-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-plus p-color-1" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Add another comp")
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("form", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.list, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "row mt-2 flex-nowrap",
          key: index
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, "Comp " + _toDisplayString(index + 1) + ":", 1)
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Street Address",
              value: item.address1,
              onKeyup: ($event: any) => (_ctx.updateAddressValue(index, $event.target.value)),
              required: ""
            }, null, 40, _hoisted_5),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("input", {
              type: "text",
              class: "form-control",
              placeholder: "Zip",
              value: item.zipCode,
              onKeyup: ($event: any) => (_ctx.updateZipValue(index, $event.target.value)),
              required: ""
            }, null, 40, _hoisted_8),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", {
              onClick: ($event: any) => (_ctx.removeComp(index))
            }, _hoisted_13, 8, _hoisted_11)
          ])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("span", {
          class: "noselect p-color-1 hover",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.addAnotherComp && _ctx.addAnotherComp(...args)))
        }, _hoisted_18)
      ])
    ])
  ]))
}